export default __webpack_public_path__ + "static/media/Landing-P4-Ulet-Ifansasti-Greenpeace.c63ee9f6.jpg";